export { default as TableDetails } from './TableDetails';
export { default as TableHome } from './TableHome';
export { default as TableCraftsman } from './TableCraftsman';
export { default as TableUsersManager } from './TableUsersManager';



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Management/Table/index.js